{% block sw_cms_block_config_background_image_field %}
    {% parent() %}

    <moorl-block-behaviour
        v-if="moorlIsUnlocked"
        v-bind="{ block }"
    />
{% endblock %}